import Cookies from 'js-cookie';
import useSWR from 'swr';
import { createRestApiClient } from '..';
import { cartDataInitializer } from '../../Utils/CartUtils/CartCookieManger';
import { getUserTokenSSR } from '../../Utils/commonUtils';
import { getUserIsLoggedIn, getUserToken } from '../../Utils/helper';

export const getUserCartData = (params, cookiesString) => {
  let usertoken = '';
  if (cookiesString) {
    usertoken = getUserTokenSSR(cookiesString);
  } else {
    usertoken = getUserToken();
  }
  const restApiClient = createRestApiClient();
  const url = 'api/getNewCartAmountOfUserWeb?random=' + new Date().getTime();
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        authorization: usertoken,
      },
    })
    .then((res) => res.data);
};
export const getAddressList = () => {
  const restApiClient = createRestApiClient(false, true);
  const url = 'api/address/list';
  let web_user_id = !getUserIsLoggedIn()
    ? Cookies.get('web_user_id_react')
    : null;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: { web_user_id, 'Mylo-In-App': false },
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res.data);
};
export const checkIfProductInStock = (pid) => {
  const url = '/api/productOutOfStockStatus';
  const restApiClient = createRestApiClient();
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: { productId: pid },
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res.data);
};

export const useGetCartData = () => {
  const options = {
    revalidateIfStale: false,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  };

  const { data } = useSWR(
    '/api/getNewCartAmountOfUserWeb',
    async () => {
      return getUserCartData(cartDataInitializer());
    },
    options,
  );
  return {
    data: data,
  };
};

export const getSRAccessToken = (data) => {
  const restApiClient = createRestApiClient();
  const url = '/api/getSrAccessToken';
  return restApiClient
    .request({
      method: 'POST',
      url: url,
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
      data: data,
    })
    .then((res) => res?.data?.data);
};

export const getUserDataByCartId = (data) => {
  const restApiClient = createRestApiClient();
  const url = '/api/getUserByCartId';
  return restApiClient
    .request({
      method: 'POST',
      url: url,
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
      data: data,
    })
    .then((res) => res?.data?.data);
};
